import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import BlogsDetails from "../blogdetails.js";
import BlogSidebar from "../blogSidebar.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

function BlogMaidaFreeCakes() {
  const [showSidebar, setShowSidebar] = useState(false);

  const handleClick = () => {
    window.open("https://wheatbakes.com/menu", "_blank");
  };

  return (
    <Container className="blog-page mt-4">
      <Row>
        {/* Sidebar */}
        <Col md={1} className={`blog-sidebar ${showSidebar ? "show" : "hide"}`}>
          <BlogSidebar
            blogs={BlogsDetails}
            closeSidebar={() => setShowSidebar(!showSidebar)}
            active={"maida-free-cakes-why-refined-flour-is-best-avoided"}
          />
        </Col>

        {/* Main Content */}
        <Col md={12} className="blog-content">
          {/* Toggle */}
          <div
            onClick={() => setShowSidebar(!showSidebar)}
            className="blogs-sidebar-open mb-3"
          >
            <FontAwesomeIcon
              icon={faBars}
              className="blogs-sidebar-close-icon me-2"
            />
            View Other Blogs
          </div>

          {/* Intro */}
          <div className="container row my-4">
            <div
              className="col-lg-6 col-xl-6 col-sm-12 my-2"
              data-aos="fade-left"
            >
              <h2 className="brown-text-color text-bold-600">
                Maida-Free Cakes: Why Refined Flour Is Best Avoided
              </h2>

              <p className="wheatbakes-para-justify">
                Cakes are a part of celebrations, comfort moments, and everyday
                indulgence. However, not all cakes are created equal. Most
                traditional cakes are made using refined flour, commonly known
                as maida. While <span className="fw-semibold">maida cakes</span> may taste soft and fluffy, they
                often come with hidden health concerns.
              </p>

              <p className="wheatbakes-para-justify">
                At <span className="fw-semibold">WheatBakes</span>, we believe
                desserts should nourish the body as well as satisfy cravings.
                That’s why we focus on{" "}
                <span className="fw-semibold">maida-free cakes</span> made with
                cleaner, more natural ingredients.
              </p>
            </div>

            <div
              className="col-lg-6 col-xl-6 col-sm-12 my-2"
              data-aos="fade-right"
            >
              <img
                src="/images/a-3.jpg"
                alt="Maida Free Cakes"
                className="img-fluid rounded w-100"
              />
            </div>
          </div>
          <hr />
          {/* What is Maida */}
          <h2 className="brown-text-color">
            What Is Maida and Why Is It Used?
          </h2>
          <p className="wheatbakes-para-justify">
            Maida is a highly refined form of wheat flour. During processing:
          </p>

          <ul>
            <li>The bran and germ are removed.</li>
            <li>Most natural fibers and nutrients are lost.</li>
            <li>The flour becomes highly starchy.</li>
          </ul>

          <p className="wheatbakes-para-justify">
            This makes <span className="fw-semibold">maida cakes</span> light in texture but heavy on empty calories.
          </p>
          <hr />

          {/* Health Concerns */}
          <h2 className="brown-text-color">
            Health Concerns Linked to Maida Cakes
          </h2>

          <Row className="my-4 blog-page-card">
            <Col md={4} className="mb-3 mb-md-0">
              <Card className="shadow-sm border-1 h-100">
                <Card.Body>
                  <h5 className="fw-bold brown-text-color text-align-center">
                    Low Nutritional Value
                  </h5>
                  <p>
                    Maida has little fiber or nutrients, providing calories but
                    little nourishment.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} className="mb-3 mb-md-0">
              <Card className="shadow-sm border-1 h-100">
                <Card.Body>
                  <h5 className="fw-bold brown-text-color text-align-center">
                    Blood Sugar Spikes
                  </h5>
                  <p>
                    Refined flour breaks down quickly into sugar, leading to:
                  </p>
                  <ul>
                    <li>Sudden energy crashes</li>
                    <li>Increased hunger</li>
                    <li>Higher risk of lifestyle-related health issues</li>
                  </ul>
                  <p>This makes maida a poor choice for regular desserts.</p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4} className="mb-3 mb-md-0">
              <Card className="shadow-sm border-1 h-100">
                <Card.Body>
                  <h5 className="fw-bold brown-text-color text-align-center">Digestive Issues</h5>
                  <p>
                    Maida lacks fiber, so it can cause digestive discomfort,
                    especially in children and the elderly.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <hr />

          <div className="my-5">
            <h2 className="brown-text-color text-center mb-4">
              Why Maida-Free Cakes Are a Better Choice
            </h2>

            <Row className="g-4 blog-page-card">
              {/* Card 1 */}
              <Col md={6}>
                <Card className="h-100 shadow border-1 p-3">
                  <Card.Body>
                    <h5 className="fw-bold brown-text-color">
                      1. Made with Whole Wheat Flour
                    </h5>
                    <div>Maida-free cakes use whole wheat flour, which:</div>
                    <ul className="mb-2">
                      <li>Retains natural fiber</li>
                      <li>Supports digestion</li>
                      <li>Keeps you fuller for longer</li>
                    </ul>
                    <div>
                      This makes them suitable for everyday consumption.
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Card 2 */}
              <Col md={6}>
                <Card className="h-100 shadow border-1 p-3">
                  <Card.Body>
                    <h5 className="fw-bold brown-text-color">
                      2. Clean & Natural Ingredients
                    </h5>
                    <div>
                      A truly natural cake goes beyond just removing maida. At <span className="fw-semibold">WheatBakes,</span> we follow a <span className="fw-semibold">no preservatives bakery</span> approach, focusing on:
                    </div>
                    <ul className="mb-0">
                      <li>Freshly prepared batters</li>
                      <li>Natural flavors</li>
                      <li>No unnecessary additives</li>
                    </ul>
                    <div>
                      This ensures every cake is both safe and wholesome.
                    </div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Card 3 */}
              <Col md={6}>
                <Card className="h-100 shadow border-1 p-3">
                  <Card.Body>
                    <h5 className="fw-bold brown-text-color">
                      3. Suitable for All Age Groups
                    </h5>
                    <div>Maida-free cakes are:</div>
                    <ul className="mb-0">
                      <li>Gentler on the stomach</li>
                      <li>Better for children’s nutrition</li>
                      <li>Easier for elders to digest</li>
                    </ul>
                    <div>They’re perfect for families looking for healthier dessert options.</div>
                  </Card.Body>
                </Card>
              </Col>

              {/* Card 4 */}
              <Col md={6}>
                <Card className="h-100 shadow border-1 p-3">
                  <Card.Body>
                    <h5 className="fw-bold brown-text-color">
                      4. Taste Without Compromise
                    </h5>
                    <div>
                    There’s a misconception that maida-free cakes are dry or dense. With expert baking techniques, <span className="fw-semibold">WheatBakes</span> ensures:
                    </div>
                    <ul className="mb-0">
                      <li>Soft texture</li>
                      <li>Balanced sweetness</li>
                      <li>Rich, natural flavors</li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
          <hr />

          {/* Why WheatBakes */}
          <h2 className="brown-text-color">Why Choose WheatBakes?</h2>
          <div>
          <span className="fw-semibold">WheatBakes</span> is more than just a <span className="fw-semibold">bakery</span> — we are a no-preservatives bakery committed to mindful baking. Our cakes are:
          </div>
          <ul>
            <li>100% maida-free</li>
            <li>Made with whole wheat flour</li>
            <li>Crafted using natural ingredients</li>
            <li>Designed for guilt-free enjoyment</li>
          </ul>

          <p>
            Explore our range of natural cakes{" "}
            <a href="https://wheatbakes.com/" target="_blank" rel="noreferrer">
              here
            </a>
          </p>
          <hr />
          {/* Final Thoughts */}

          <p className="wheatbakes-para-justify">
            While <span className="fw-semibold">maida cakes</span> may be widely available, their long-term health
            impact makes them best avoided. Switching to maida-free cakes made
            with whole wheat and natural ingredients is a simple yet powerful
            step toward better eating habits.
          </p>

          <p className="wheatbakes-para-justify">
            Choose <span className="fw-semibold">WheatBakes</span> — where every
            slice is baked with care, quality, and wellness in mind.
          </p>

          {/* CTA */}
          <div className="my-5 text-center">
            <button className="wheatbakes-btn" onClick={handleClick}>
              EXPLORE MAIDA-FREE CAKES
            </button>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default BlogMaidaFreeCakes;
